var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('GenericListTableV2',{attrs:{"parentID":this.parentID,"title":"Device Types","headers":[
        { text: 'ID', value: 'id' },
        { text: 'Device Type Name', value: 'typename' },
        { text: 'Device Type Description', value: 'description', editable: true }
      ],"url":"/schemas/devicetypes","apiResponseField":"devicetypes","onClickRoute":"DeviceTypeSingle","onClickParams":_vm.getOnClickParams}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }